import React from "react";
import { Route, Redirect, Switch, withRouter } from "react-router-dom";

import { build_route_switch } from "./routing/appRouter";

import NotFound from "./pages/notfound";

import AppContext from "./AppContext";
import asyncComponent from "./helpers/AsyncFunc";

import { config } from "./settings/config";

const state_routing = (state, state_order, location) => {
  /* The Routes for state redirection */
  let state_routes = {
    sq: "/security/security-questions",
    token: "/security/device-token",
    tc: "/security/terms-conditions",
  };

  /* Loop over the state order*/
  for (let s of state_order) {
    /* Check State Status */
    if (
      (state[s] !== undefined && state[s] === 0 && state_routes[s] !== undefined) ||
      (state[s] === undefined && state_routes[s] !== undefined)
    ) {
      /* Check we aren't currently there */
      if (location !== state_routes[s]) {
        return <Redirect key="stateroute" to={state_routes[s]} />;
      } else {
        return false;
      }
    }
  }

  return false;
};

class Routes extends React.Component {
  render() {
    const context = { ...this.props.context, navigate: this.props.history.push, history: this.props.history };
    return (
      <AppContext.Provider value={context}>
        <Switch>
          {/* Unauthenticated Routes */}
          <Route exact path={"/signin"} component={asyncComponent(() => import("./pages/public/signin"))} />
          <Route
            exact
            path={"/forgotpassword"}
            component={asyncComponent(() => import("./pages/public/forgotpassword"))}
          />

          <Route exact path={"/activate/:code"} component={asyncComponent(() => import("./pages/public/activate"))} />
          <Route exact path={"/challenge"} component={asyncComponent(() => import("./pages/public/challenge"))} />
          {config?.self_register_enabled && (
            <Route exact path={"/register"} component={asyncComponent(() => import("./pages/public/register"))} />
          )}
          {config?.self_register_enabled && (
            <Route
              exact
              path={"/register/:registrationCode"}
              component={asyncComponent(() => import("./pages/public/register"))}
            />
          )}
          {!this.props.context.isAuthenticated && !this.props.context.isAuthenticating ? (
            <Redirect
              to={{
                pathname: "/signin",
                state: { referrer: window.location.pathname },
              }}
            />
          ) : (
            false
          )}

          {/* This manages the state based redirection */}
          {this.props.context.user_state !== null
            ? state_routing(this.props.context.user_state, this.props.context.state_order, window.location.pathname)
            : false}

          {/* Security Routes */}
          <Route
            key="termsconditions"
            path="/security/terms-conditions"
            exact
            component={asyncComponent(() => import("./pages/security/termsConditions"))}
          />
          <Route
            key="securityquestions"
            path="/security/security-questions"
            exact
            component={asyncComponent(() => import("./pages/security/securityQuestions"))}
          />
          <Route
            key="devicetokens"
            path="/security/device-token"
            exact
            component={asyncComponent(() => import("./pages/security/deviceTokens"))}
          />

          {/* Authenticated Routes */}
          {build_route_switch(
            this.props.context.permissions[this.props.context.active_role],
            this.props.context.features
          ).map(r => r)}
          <Route exact path={"/"}>
            <Redirect to={{ pathname: this.props.context.defaultPage }} />
          </Route>
          <Route key="notfound" component={NotFound} />
        </Switch>
      </AppContext.Provider>
    );
  }
}

export default withRouter(Routes);
